import { getMsalInstance } from '../config/msal';

/** @type {Promise<import('@azure/msal-browser').AuthenticationResult|null>|null} */
let msalRedirectPromise = null;

/**
 * Ensures MSAL finishes handling any pending redirect before interactive calls.
 * Must be invoked once on page load and before loginRedirect.
 * @returns {Promise<import('@azure/msal-browser').AuthenticationResult|null>}
 *
 * @created_at 22/06/2025 by AI (Composer)
 */
export const ensureMsalRedirectHandled = async () => {
	const msal = getMsalInstance();
	if (!msalRedirectPromise) {
		msalRedirectPromise = msal.handleRedirectPromise();
	}
	return msalRedirectPromise;
};

/**
 * Redirects the user to Microsoft login via MSAL.
 * @returns {Promise<void>}
 *
 * @created_at 22/06/2025 by AI (Composer)
 * @changed_at 22/06/2025 by AI (Composer) — MSAL v2 API (no initialize())
 */
export const loginWithMicrosoft = async () => {
	const msal = getMsalInstance();
	await ensureMsalRedirectHandled();
	await msal.loginRedirect({
		scopes: ['openid', 'profile', 'email'],
	});
};

/**
 * Handles the MSAL redirect callback and returns the Microsoft ID token.
 * @returns {Promise<string|null>}
 *
 * @created_at 22/06/2025 by AI (Composer)
 * @changed_at 22/06/2025 by AI (Composer) — removed debug logging
 */
export const handleMicrosoftRedirect = async () => {
	const result = await ensureMsalRedirectHandled();

	if (!result) return null;

	return result.idToken;
};
